import ScrollItem from './ScrollItem';
import './Zoku.css';
import './Glitch.css';
import TypeH2Webp from '../img/Type-h2.webp';
import TypeH2 from '../img/Type-h2.png';

import ZokuSection01BigImageWebp from '../img/Zoku-section01/Zoku-section01-bigImage.webp';
import ZokuSection01BigImage from '../img/Zoku-section01/Zoku-section01-bigImage.png';
import ZokuSection01TitleWebp from '../img/Zoku-section01/Zoku-section01-title.webp';
import ZokuSection01Title from '../img/Zoku-section01/Zoku-section01-title.png';
import ZokuSection01Icon01Webp from '../img/Zoku-section01/Zoku-section01-icon01.webp';
import ZokuSection01Icon01 from '../img/Zoku-section01/Zoku-section01-icon01.png';
import ZokuSection01Icon02Webp from '../img/Zoku-section01/Zoku-section01-icon02.webp';
import ZokuSection01Icon02 from '../img/Zoku-section01/Zoku-section01-icon02.png';
import ZokuSection01Icon03Webp from '../img/Zoku-section01/Zoku-section01-icon03.webp';
import ZokuSection01Icon03 from '../img/Zoku-section01/Zoku-section01-icon03.png';
import ZokuSection01Icon04Webp from '../img/Zoku-section01/Zoku-section01-icon04.webp';
import ZokuSection01Icon04 from '../img/Zoku-section01/Zoku-section01-icon04.png';

import ZokuSection02BigImageWebp from '../img/Zoku-section02/Zoku-section02-bigImage.webp';
import ZokuSection02BigImage from '../img/Zoku-section02/Zoku-section02-bigImage.png';
import ZokuSection02TitleWebp from '../img/Zoku-section02/Zoku-section02-title.webp';
import ZokuSection02Title from '../img/Zoku-section02/Zoku-section02-title.png';
import ZokuSection02Icon01Webp from '../img/Zoku-section02/Zoku-section02-icon01.webp';
import ZokuSection02Icon01 from '../img/Zoku-section02/Zoku-section02-icon01.png';
import ZokuSection02Icon02Webp from '../img/Zoku-section02/Zoku-section02-icon02.webp';
import ZokuSection02Icon02 from '../img/Zoku-section02/Zoku-section02-icon02.png';
import ZokuSection02Icon03Webp from '../img/Zoku-section02/Zoku-section02-icon03.webp';
import ZokuSection02Icon03 from '../img/Zoku-section02/Zoku-section02-icon03.png';
import ZokuSection02Icon04Webp from '../img/Zoku-section02/Zoku-section02-icon04.webp';
import ZokuSection02Icon04 from '../img/Zoku-section02/Zoku-section02-icon04.png';

import ZokuSection03BigImageWebp from '../img/Zoku-section03/Zoku-section03-bigImage.webp';
import ZokuSection03BigImage from '../img/Zoku-section03/Zoku-section03-bigImage.png';
import ZokuSection03TitleWebp from '../img/Zoku-section03/Zoku-section03-title.webp';
import ZokuSection03Title from '../img/Zoku-section03/Zoku-section03-title.png';
import ZokuSection03Icon01Webp from '../img/Zoku-section03/Zoku-section03-icon01.webp';
import ZokuSection03Icon01 from '../img/Zoku-section03/Zoku-section03-icon01.png';
import ZokuSection03Icon02Webp from '../img/Zoku-section03/Zoku-section03-icon02.webp';
import ZokuSection03Icon02 from '../img/Zoku-section03/Zoku-section03-icon02.png';
import ZokuSection03Icon03Webp from '../img/Zoku-section03/Zoku-section03-icon03.webp';
import ZokuSection03Icon03 from '../img/Zoku-section03/Zoku-section03-icon03.png';
import ZokuSection03Icon04Webp from '../img/Zoku-section03/Zoku-section03-icon04.webp';
import ZokuSection03Icon04 from '../img/Zoku-section03/Zoku-section03-icon04.png';

import SectionDecoration from './SectionDecoration';

export default function Zoku() {
    return (
        <section className="Zoku" id="zoku">
            <div className="Zoku__descriptionContainer">
                <ScrollItem>
                    <h2 className="Zoku__h2">
                        <div className="Zoku__h2__img">
                            <picture>
                                <source type="image/webp" srcSet={TypeH2Webp} />
                                <img src={TypeH2} alt="Type" />
                            </picture>
                        </div>
                    </h2>
                </ScrollItem>
                <ScrollItem>
                    <p className="Zoku__description">The BŌSŌ NFT consists of 3 types.</p>
                </ScrollItem>
            </div>

            <div className="ZokuSection">
                <div className="ZokuSection__inner">
                    {/* <ScrollItem> */}
                    <div className="ZokuSection__bigImage">
                        <picture>
                            <source type="image/webp" srcSet={ZokuSection01BigImageWebp} />
                            <img src={ZokuSection01BigImage} alt="Zoku NFT image" />
                        </picture>
                    </div>
                    {/* </ScrollItem> */}

                    <div className="ZokuSection_more">
                        <h3 className="ZokuSection__title">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={ZokuSection01TitleWebp} />
                                    <img src={ZokuSection01Title} alt="Human" />
                                </picture>
                            </ScrollItem>
                        </h3>
                        <div className="Zoku__iconContainer">
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection01Icon01Webp} />
                                        <img src={ZokuSection01Icon01} alt="Zoku NFT image 01" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection01Icon02Webp} />
                                        <img src={ZokuSection01Icon02} alt="Zoku NFT image 02" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection01Icon03Webp} />
                                        <img src={ZokuSection01Icon03} alt="Zoku NFT image 03" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection01Icon04Webp} />
                                        <img src={ZokuSection01Icon04} alt="Zoku NFT image 04" />
                                    </picture>
                                </ScrollItem>
                            </div>
                        </div>
                        {/* Zoku__iconContainer */}

                    </div>
                    {/* ZokuSection_more */}

                </div>
                {/* ZokuSection__inner */}

            </div>
            {/* ZokuSection */}

            <div className="ZokuSection right">
                <div className="ZokuSection__inner">
                    <div className="ZokuSection__bigImage">
                        <picture>
                            <source type="image/webp" srcSet={ZokuSection02BigImageWebp} />
                            <img src={ZokuSection02BigImage} alt="Zoku NFT image" />
                        </picture>
                    </div>

                    <div className="ZokuSection_more">
                        <h3 className="ZokuSection__title">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={ZokuSection02TitleWebp} />
                                    <img src={ZokuSection02Title} alt="Human" />
                                </picture>
                            </ScrollItem>
                        </h3>
                        <div className="Zoku__iconContainer">
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection02Icon01Webp} />
                                        <img src={ZokuSection02Icon01} alt="Zoku NFT image 01" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection02Icon02Webp} />
                                        <img src={ZokuSection02Icon02} alt="Zoku NFT image 02" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection02Icon03Webp} />
                                        <img src={ZokuSection02Icon03} alt="Zoku NFT image 03" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection02Icon04Webp} />
                                        <img src={ZokuSection02Icon04} alt="Zoku NFT image 04" />
                                    </picture>
                                </ScrollItem>
                            </div>
                        </div>
                        {/* Zoku__iconContainer */}

                    </div>
                    {/* ZokuSection_more */}

                </div>
                {/* ZokuSection__inner */}

            </div>
            {/* ZokuSection */}

            <div className="ZokuSection">
                <div className="ZokuSection__inner">
                    <div className="ZokuSection__bigImage">
                        <picture>
                            <source type="image/webp" srcSet={ZokuSection03BigImageWebp} />
                            <img src={ZokuSection03BigImage} alt="Zoku NFT image" />
                        </picture>
                    </div>

                    <div className="ZokuSection_more">
                        <h3 className="ZokuSection__title">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={ZokuSection03TitleWebp} />
                                    <img src={ZokuSection03Title} alt="Human" />
                                </picture>
                            </ScrollItem>
                        </h3>
                        <div className="Zoku__iconContainer">
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection03Icon01Webp} />
                                        <img src={ZokuSection03Icon01} alt="Zoku NFT image 01" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection03Icon02Webp} />
                                        <img src={ZokuSection03Icon02} alt="Zoku NFT image 02" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection03Icon03Webp} />
                                        <img src={ZokuSection03Icon03} alt="Zoku NFT image 03" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="ZokuSection__img">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={ZokuSection03Icon04Webp} />
                                        <img src={ZokuSection03Icon04} alt="Zoku NFT image 04" />
                                    </picture>
                                </ScrollItem>
                            </div>
                        </div>
                        {/* Zoku__iconContainer */}

                    </div>
                    {/* ZokuSection_more */}

                </div>
                {/* ZokuSection__inner */}

            </div>
            {/* ZokuSection */}

            {/* decoration */}
            <SectionDecoration />
        </section>
    )
}